import _regeneratorRuntime from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import { getBilldatalist } from "@/api/bizBillingdata"; //  此处请自行替换地址
import QChart from "@/components/queryChart";
import TopChart from "@/components/topChart";
import { formatTimeToStr } from "@/utils/date";
export default {
  name: "queries",
  props: {
    param: {
      type: Object,
      required: false
    }
  },
  data: function data() {
    return {
      qData: {
        loading: true,
        total: 0
      },
      topDateRange: [new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 1), new Date().getTime()],
      allTimes: []
    };
  },
  components: {
    QChart: QChart,
    TopChart: TopChart
  },
  methods: {
    //添加refreshData方法进行自动设置数据
    getQueries: function getQueries() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, times, counts, total;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.qData = {
                loading: true
              };
              _context.next = 3;
              return getBilldatalist(_this.param);
            case 3:
              res = _context.sent;
              times = [];
              counts = [];
              total = 0;
              res.data.map(function (info) {
                _this.allTimes.push(info.timestamp);
                times.push(formatTimeToStr(info.timestamp * 1000, 'MM-dd hh:mm'));
                counts.push(info.count);
                total += info.count;
              });
              _this.qData = {
                data: [times, counts],
                total: total,
                dataZoomShow: _this.param.dataZoomShow
              };
              // this.topDateRange=[this.allTimes[0] * 1000, this.allTimes[this.allTimes.length-1] * 1000]
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getPointDate: function getPointDate(pointIndex) {
      this.pointIndex = pointIndex;
      this.topRangeDate = [this.allTimes[this.pointIndex] * 1000, this.allTimes[this.pointIndex] * 1000 + 5 * 60 * 1000];
    },
    getRangeDate: function getRangeDate(start, end) {
      console.log(start, end);
      var count = this.allTimes.length;
      var startIndex = Math.floor(count * start / 100);
      var endIndex = Math.floor(count * end / 100);
      if (endIndex == count) {
        endIndex = count - 1;
      }
      this.topDateRange = [this.allTimes[startIndex] * 1000, this.allTimes[endIndex] * 1000];
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    this.$nextTick(function () {
      _this2.getQueries();
    });
  },
  watch: {
    param: {
      deep: true,
      handler: function handler(val) {
        this.getQueries(val);
      }
    }
  }
};